import { render, staticRenderFns } from "./jiedanList.vue?vue&type=template&id=59106d0c&scoped=true&"
import script from "./jiedanList.vue?vue&type=script&lang=js&"
export * from "./jiedanList.vue?vue&type=script&lang=js&"
import style0 from "./jiedanList.vue?vue&type=style&index=0&id=59106d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59106d0c",
  null
  
)

export default component.exports